/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ClearIcon from "@mui/icons-material/Clear";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Chip,
  Box,
  Avatar,
  Button,
  Modal,
  Snackbar,
  Alert,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import DocumentUpload from "../components/DocumentUpload";
import { RestartAlt, ZoomIn, ZoomOut } from "@mui/icons-material";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const getCompanyUserProfile = async (user, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    let url = "";
    if (authData?.type === "ap_user") {
      url = `/api/v1/ap_user/ops/${user}`;
    } else {
      url = `/api/v1/${authData?.type}/ap_user/${user}`;
    }
    const { data } = await axios.get(url, config);
    if (data.success) {
      setMyState((prev) => {
        return { ...prev, profile: data.data };
      });
    }

    setLinks(data.data.documents, setMyState);
  } catch (e) {
    console.log(e);
  }
};

const getRolesCompanies = async (setRoles, setCompanies, setMyState) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const roledata = await axios.get(
      `/api/v1/${userData.type}/role?user_type=ap_company_user`,
      config
    );

    const companydata = await axios.get(
      `/api/v1/${userData.type}/ap_company`,
      config
    );
    if (roledata.data.success) {
      setRoles(roledata.data.data);
    }
    if (companydata.data.success) {
      setCompanies(companydata.data.data.data);
    }
    setMyState((prev) => {
      return { ...prev, loader: false };
    });
  } catch (e) {
    setMyState((prev) => {
      return { ...prev, loader: false };
    });
    console.log(e);
  }
};

const getUrls = async (documents, setUrls, setLoader) => {
  try {
    setLinks(documents, setUrls, setLoader);
  } catch (e) {
    console.log(e);
    setLoader(false);
  }
};

const setLinks = (document, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    document.map((doc) => {
      const type = doc?.document_storage_info?.key?.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${doc.document_storage_info.key}`,
        name: doc.document_title,
        type: type,
        key: doc?.document_storage_info?.key,
      });
    });
    sendRequests(urls, setMyState);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setMyState((prev) => {
        return { ...prev, loader: false };
      });
    }
    let n = 0;
    let allUrls = [];
    let promiseArr = urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }
      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          }
          if (n === num) {
            setMyState((prev) => {
              return { ...prev, urls: allUrls };
            });
            setMyState((prev) => {
              return { ...prev, loader: false };
            });
          }
        });
    });

    // setLoader(false);
  } catch (e) {
    setMyState((prev) => {
      return { ...prev, loader: false };
    });
    console.log(e);
  }
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Mob = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    display: none;
  }
`;
const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function DefaultTextFields({ profile, urls, id, setMyState, myState }) {
  const [role, setRole] = useState(profile?.role?.role_name);
  const [ApCompany, setApCompany] = React.useState(profile?.ap_company);
  const [modalImgHeight, setModalImgHeight] = useState(70);
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [del, setDelete] = useState(false);
  const [message, setMessage] = useState("");

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleCloseSnack = () => {
    setState({ ...state, op: false });
  };
  const [err, setErr] = useState("");
  const formData = new FormData();
  const [success, setSuccess] = useState(false);

  const [open, setOpen] = React.useState(false);
  const [u, setU] = useState();
  const [type, setType] = useState();
  const handleOpen = (url, type) => {
    setU(url);
    setType(type);
    setOpen(true);
    setModalImgHeight(70);
  };
  const [images, setImages] = useState({});
  const [documents, setDocuments] = useState({});
  const [openAddDoc, setOpenAdddoc] = useState(false);
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };
  const handleOpenDoc = () => {
    setOpenAdddoc(true);
  };
  const handleClose = () => setOpen(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  useEffect(() => {
    getRolesCompanies(setRoles, setCompanies, setMyState);
  }, [profile]);

  const deleteDocument = async (key) => {
    try {
      setMyState((prev) => {
        return { ...prev, loader: true };
      });
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.delete(
        `/api/v1/${authData?.type}/media/ap_user/${id}/${key}`,
        config
      );
      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        window.location.reload();
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setMyState((prev) => {
        return { ...prev, loader: false };
      });
      console.log(e);
    }
  };
  const addDocuments = async () => {
    try {
      let br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        setMyState((prev) => {
          return { ...prev, loader: true };
        });
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        const { data } = await axios.post(
          `/api/v1/${authData?.type}/media/ap_user/${id}`,
          formData,
          config
        );
        if (data.success) {
          setSuccess(true);
          setErr("");
          setMessage("Documents Added Successfully");
          snackRef.current.click();
          window.location.reload();
        }
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setMyState((prev) => {
        return { ...prev, loader: false };
      });
      console.log(e);
    }
  };

  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={op}
        onClose={handleCloseSnack}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity="success">
            {message}
          </Alert>
        ) : null}
      </Snackbar>
      {!myState.loader ? (
        <form>
          <Card mb={6}>
            <CardContent>
              <form noValidate autoComplete="off">
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h4" gutterBottom>
                        AP User Profile Page
                      </Typography>
                    </Grid>
                    {urls.map((url, i) => {
                      if (url.name === "profile_picture") {
                        return <BigAvatar src={url.url} />;
                      }
                    })}
                    <Grid item xs={12} lg={12} md={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-mutiple-chip-label">
                          Alpha Plus Companies{" "}
                        </InputLabel>
                        {ApCompany ? (
                          <Select
                            labelId="demo-mutiple-chip-label"
                            value={ApCompany}
                            id="demo-mutiple-chip"
                            inputProps={{ readOnly: "true" }}
                            multiple
                            input={
                              <OutlinedInput
                                id="select-multiple-chip"
                                variant="contained"
                                label="Alpha Plus Companies"
                              />
                            }
                            renderValue={(selected) => (
                              <div>
                                {selected.map((value) => (
                                  <Chip key={value.name} label={value.name} />
                                ))}
                              </div>
                            )}
                            MenuProps={MenuProps}
                          >
                            <MenuItem value={""} disabled>
                              {"Select Alpha Plus Companies"}
                            </MenuItem>
                            {companies.length &&
                              companies.map((company) => (
                                <MenuItem key={company?._id} value={company}>
                                  {company.name}
                                </MenuItem>
                              ))}
                          </Select>
                        ) : null}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        id="standard-required"
                        value={profile?.name}
                        inputProps={{ readOnly: true }}
                        label="Name"
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        id="standard-required"
                        fullWidth
                        value={profile?.email_address}
                        inputProps={{ readOnly: true }}
                        label="Email"
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.phone_number}
                        fullWidth
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Mobile"
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={role}
                        inputProps={{ readOnly: true }}
                        fullWidth
                        label="Role"
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="Address Line 1"
                        value={profile?.address_line_one}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="Address Line 2"
                        value={profile?.address_line_two}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="Pincode"
                        value={profile?.pincode}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="State"
                        value={profile?.state}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="City"
                        value={profile?.city}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </form>
            </CardContent>
          </Card>

          <Modal open={open} onClose={handleClose}>
            <Card sx={style}>
              <CardContent>
                <Paper>
                  <Grid container justifyContent="center" spacing={5}>
                    <Grid
                      item
                      xs={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight + 5)}
                      >
                        <ZoomIn />
                      </IconButton>
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight - 5)}
                      >
                        <ZoomOut />
                      </IconButton>
                      <IconButton onClick={() => setModalImgHeight(70)}>
                        <RestartAlt />
                      </IconButton>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        maxHeight: "72.5vh",
                        overflowY: "scroll",
                      }}
                    >
                      {type !== "pdf" ? (
                        <Box
                          component={"img"}
                          src={u}
                          height={modalImgHeight.toString() + "vh"}
                          width="auto"
                        />
                      ) : (
                        <iframe
                          height={(modalImgHeight + 420).toString() + "vh"}
                          width={(modalImgHeight + 420).toString() + "vh"}
                          src={u}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          </Modal>

          <Modal
            open={openAddDoc}
            onClose={handleDownDoc}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                align="center"
                color="primary"
              >
                Add Documents
              </Typography>
              <DocumentUpload
                documents={documents}
                setDocuments={setDocuments}
                images={images}
                setImages={setImages}
              />
              <Button onClick={addDocuments}>Add</Button>
            </Box>
          </Modal>
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="h4" gutterBottom>
                      Document Details
                    </Typography>
                  </Grid>
                </Grid>
                {!profile.documents.length ? (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary" gutterBottom>
                      No Documents Added
                    </Typography>
                  </Grid>
                ) : null}
                {profile.documents &&
                  profile.documents.map((document, i) => {
                    if (urls[i]?.name !== "profile_picture") {
                      return (
                        <Paper
                          style={{ display: "flex", alignItems: "center" }}
                          mt={3}
                        >
                          <Box
                            component="img"
                            width="90px"
                            height="80px"
                            onClick={() =>
                              handleOpen(urls[i]?.url, urls[i]?.type)
                            }
                            src={
                              urls[i]?.type === "pdf"
                                ? "/static/img/images/pdf.png"
                                : urls[i]?.url
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <TextField
                            fullWidth
                            margin="dense"
                            m={2}
                            style={{ marginLeft: 32 }}
                            inputProps={{ readOnly: true }}
                            id="standard-required"
                            label="Document Name"
                            value={urls[i]?.name || ""}
                          />
                          {!del ? (
                            <Mob>
                              <Grid item>
                                <a
                                  href={urls[i]?.url}
                                  style={{
                                    color: "inherit",
                                    textDecoration: "inherit",
                                  }}
                                  download={`${urls[i]?.name}.${urls[i]?.type}`}
                                >
                                  <FileDownloadIcon
                                    style={{
                                      marginLeft: 32,
                                      cursor: "pointer",
                                    }}
                                  />
                                </a>
                              </Grid>
                            </Mob>
                          ) : (
                            <Grid item>
                              <ClearIcon
                                onClick={() => deleteDocument(urls[i]?.key)}
                                style={{
                                  marginLeft: 32,
                                  cursor: "pointer",
                                }}
                              />
                            </Grid>
                          )}
                        </Paper>
                      );
                    }
                  })}
              </Paper>
            </CardContent>
          </Card>
        </form>
      ) : (
        <Loading />
      )}
    </>
  );
}
function ApUserProfile() {
  const { user_id } = useParams();
  const navigate = useNavigate();

  const [myState, setMyState] = useState({
    profile: {},
    urls: [],
    loader: true,
  });

  useEffect(() => {
    getCompanyUserProfile(user_id, setMyState);
  }, []);
  if (!myState.loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              AP USER PROFILE
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/users/ap-users">
                Ap Users
              </Link>
              <Typography>Profile </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <DefaultTextFields
              myState={myState}
              setMyState={setMyState}
              id={user_id}
              urls={myState.urls}
              profile={myState.profile}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default ApUserProfile;
